import React from 'react';
import PropTypes from 'prop-types';


export default class PlaceholderError extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div className="row">
                <div className="col-12">
                    <div className="card m-b-20">
                        <div className="card-block text-center">
                            <div className="alert ex-page-content text-center" role="alert">
                                <h1>{this.props.error.code === undefined ? 500 : this.props.error.code}</h1>
                                <p>{this.props.error.message}</p>
                            </div>
                            <button onClick={this.context.router.history.goBack} className="btn btn-primary btn-lgt col-sm-3">Back</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

PlaceholderError.contextTypes = {
    router: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./web/src/components/common/PlaceholderError.jsx